// ** React Imports
import { Fragment } from "react";

// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import Link from "components/layout/Link";

// ** Custom Hooks
import { compute as preferencesCompute } from "hooks/filters/useFilterPreferences";
import SexIcon from "components/icons/SexIcon";
import SportIcon from "components/icons/SportIcon";
import HobbyIcon from "components/icons/HobbyIcon";
import LifeStyleIcon from "components/icons/LifeStyleIcon";
import CultureIcon from "components/icons/CultureIcon";
import FoodIcon from "components/icons/FoodIcon";

// #####################################################

const DataPreferences = () => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const userTastes = useSelector((state) => state.userProfileMain.tastes);

	const userTastesObject = useSelector(
		(state) => state.userProfileMain.tastesObject,
	);

	// #####################################################
	const renderNewPreferences = ({ data, transKey, icon }) => {
		if (!data.length) {
			return null;
		}

		const result = data
			.filter((item) => item !== null)
			.sort((a, b) => {
				return t(`filtersAndSelectors:preferences.${a}`).localeCompare(
					t(`filtersAndSelectors:preferences.${b}`),
					undefined,
					{
						numeric: false,
						sensitivity: "base",
					},
				);
			})
			.map((item, index) => {
				const to = {
					pathname: `/search/preferences/${preferencesCompute.valueToUrl(
						item,
					)}`,
					state: {
						notUseUserSex: true,
					},
				};

				return (
					<Fragment key={`item-${item}`}>
						<Link to={to} underline color="primary" bold>
							{t(`filtersAndSelectors:preferences.${item}`)}
						</Link>
						{data[index + 1] && ", "}
					</Fragment>
				);
			});
		return (
			<Block flex>
				<Block>
					<Text mr={1}>
						{icon}
						{transKey}:
					</Text>
					{result}
				</Block>
			</Block>
		);
	};

	return userTastes.length !== 0 ? (
		<Block>
			{renderNewPreferences({
				data: userTastesObject.sex,
				transKey: t("filtersAndSelectors:categoryPreferences.0"),
				icon: <SexIcon />,
			})}
			{renderNewPreferences({
				data: userTastesObject.sport,
				transKey: t("filtersAndSelectors:categoryPreferences.2"),
				icon: <SportIcon />,
			})}
			{renderNewPreferences({
				data: userTastesObject.hobby,
				transKey: t("filtersAndSelectors:categoryPreferences.3"),
				icon: <HobbyIcon />,
			})}
			{renderNewPreferences({
				data: userTastesObject.life_style,
				transKey: t("filtersAndSelectors:categoryPreferences.5"),
				icon: <LifeStyleIcon />,
			})}
			{renderNewPreferences({
				data: userTastesObject.culture,
				transKey: t("filtersAndSelectors:categoryPreferences.4"),
				icon: <CultureIcon />,
			})}
			{renderNewPreferences({
				data: userTastesObject.food,
				transKey: t("filtersAndSelectors:categoryPreferences.1"),
				icon: <FoodIcon />,
			})}
		</Block>
	) : null;
};

// #####################################################

export default DataPreferences;

// #####################################################
